import { PAYMENT_METHOD_TYPE_TO_DISPLAYABLE_NAME } from './checkout.constants';
export function getDisplayablePaymentMethod() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return PAYMENT_METHOD_TYPE_TO_DISPLAYABLE_NAME[type.toLowerCase()] || '';
}